import React from 'react';

import { Link, withRouter } from 'react-router';
import Icon from '../Icon/Icon';
import { useSelector } from 'react-redux';

import './Breadcrumb.scss';

const Display = ({ segment }) => {
  if (segment === 'resource') {
    return (
      <span className="loader-dots">
        <i className="fa fa-circle loader-dot" />
        <i className="fa fa-circle loader-dot" />
        <i className="fa fa-circle loader-dot" />
      </span>
    );
  }

  return <span className={'capitalise'}>{segment}</span>;
};
const uuidPattern = /[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}/;
const Breadcrumb = ({ location }) => {
  const { pathname } = location;
  const pattern = /(.*)\/\/[a-zA-Z:.0-9-@]+\//;
  const p = pathname.substr(1, pathname.length);

  const { resources } = useSelector((state) => state.breadcrumb);

  const segments =
    p
      ?.split(/[?#]/)[0]
      .replace(pattern, '')
      .split('/') ?? [];

  if (segments[1] === 'source-types') {
    segments.splice(1, 2, 'Source Groups');
  }

  const filteredSegment = (s) => (s.match(uuidPattern) ? resources?.[s] : s);

  const notClickablePaths = ['resource'];
  let path = '';

  return (
    <div className="breadcrumb-box">
      <ul className="breadcrumb">
        <li className="li-home">
          <Link to="/dashboard" onlyActiveOnIndex>
            <Icon name="home" />
          </Link>
        </li>
        {segments.map((segment, part) => {
          const humanReadableSegment = filteredSegment(segment);

          path += '/' + segment;
          if (!humanReadableSegment) {
            return;
          }
          if (segments.length === part + 1) {
            return (
              <li key={part} className="li-active">
                <span className="last-child-padding">
                  <Link onlyActiveOnIndex>
                    <Display segment={humanReadableSegment} />
                  </Link>
                </span>
              </li>
            );
          }
          if (notClickablePaths.indexOf(humanReadableSegment) !== -1) {
            return (
              <li key={part} className="li-breadcrumb">
                <Link to={''} activeClassName="active" onlyActiveOnIndex>
                  <Display segment={humanReadableSegment} />
                </Link>
              </li>
            );
          }
          return (
            <li key={part} className="li-breadcrumb">
              <Link to={path} activeClassName="active" onlyActiveOnIndex>
                <Display segment={humanReadableSegment} />
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default withRouter(Breadcrumb);
